
<script>
    import moment from 'moment';
    import cancellationItem from "shared/Components/cancellationItem.vue";
    import { groupArrayBy } from "shared/Utilities/objectUtilities";

    let today = moment().startOf('day'),
        dateFormat = "dddd, MMMM Do";

    export default {
        props: {
            items: Array
        },
        methods: {
            formatDate(date) {
                var dateObject = moment(date);
                return dateObject.format(dateFormat) + (dateObject.isSame(today) ? ' - Today' : '');
            }
        },
        computed: {
            upcomingFlights() {
                return groupArrayBy(this.items
                        .filter(x => moment(x.scheduledDepartureDate).isSameOrAfter(today))
                        .sort((a, b) => moment(a.scheduledDepartureDate).diff(b.scheduledDepartureDate, 'days')), 
                    x => this.formatDate(x.scheduledDepartureDate));
            },
            pastFlights() {
                return groupArrayBy(this.items
                        .filter(x => moment(x.scheduledDepartureDate).isBefore(today))
                        .sort((a, b) => moment(b.scheduledDepartureDate).diff(a.scheduledDepartureDate, 'days')), 
                    x => this.formatDate(x.scheduledDepartureDate));
            }
        },
        components: {
            cancellationItem
        }
    }
</script>

<template>
    <div v-if="items.length" class="cancellations-container">
        <div class="cancellations">
            <div class="cancellations-header">
                Upcoming<span class="hide-sm hide-md">&nbsp;Flight</span><span class="hide-sm">&nbsp;Cancellations</span>
            </div>
            <div v-if="!upcomingFlights.length" class="italic">No upcoming&nbsp;<span class="hide-sm">flight&nbsp;</span>cancellations</div>
            <cancellation-item v-else :item="group" v-for="group in upcomingFlights" :key="group.group"></cancellation-item>
        </div>
        <div class="cancellations">
            <div class="cancellations-header">
                Past<span class="hide-sm hide-md">&nbsp;Flight</span><span class="hide-sm">&nbsp;Cancellations</span>
            </div>
            <div v-if="!pastFlights.length" class="italic">No past&nbsp;<span class="hide-sm">flight&nbsp;</span>cancellations</div>
            <cancellation-item v-else :item="group" v-for="group in pastFlights" :key="group.group"></cancellation-item>
        </div>
    </div>
    <div v-else>
        There are currently no cancellations.
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .cancellations-container {
        .cancellations {
            .cancellations-header {
                color: @frontier-gray-xxdark;
                font-size: 18px;
                font-weight: 700;
                text-transform: uppercase;
                padding-bottom: 3px;
            }

            &:not(:first-child) {
                margin-top: 20px;

                @media @tablet {
                    margin-top: 10px;
                }
            }
        }
    }
</style>
